<template>
<div class="cards-carousel" @touchstart.passive="handleTouchStart" @touchend.passive="handleTouchEnd">
    <div class="carousel-container" v-if="type === 'Article'" :style="{ left: this.pixelsToMovePerSwipe + 'px' }">
        <ArticleCard v-for="(card, i) in cards" :key="i" :cardDetails="card" :class="{ active: activeCardIndex === i }" />
    </div>
    <div class="carousel-container" v-else-if="type === 'Action'" :style="{ left: this.pixelsToMovePerSwipe + 'px' }">
        <ActionCard v-for="(card, i) in cards" :key="i" :cardDetails="card" :class="{ active: activeCardIndex === i }" />
    </div>
    <div class="carousel-container" v-else-if="type === 'CECourse'" :style="{ left: this.pixelsToMovePerSwipe + 'px' }">
        <CECourseCard type="CECourse" v-for="(card, i) in cards" :key="i" :cardDetails="card" :class="{ active: activeCardIndex === i }" />
    </div>
    <div class="carousel-container-one" v-else-if="type === 'CECourseOne'" :style="{ left: this.pixelsToMovePerSwipe + 'px' }">
        <CECourseCard type="CECourseOne" v-for="(card, i) in cards" :key="i" :cardDetails="card" :class="{ active: activeCardIndex === i }" />
    </div>
    <div class="carousel-container-two " v-else-if="type === 'CECourseTwo'" :style="{ left: this.pixelsToMovePerSwipe + 'px' }">
        <CECourseCard type="CECourseTwo" v-for="(card, i) in cards" :key="i" :cardDetails="card" :class="{ active: activeCardIndex === i }" />
    </div>
    <div class="carousel-container reviews-container" v-else-if="type === 'Reviews'" :style="{ left: (this.pixelsToMovePerSwipe+(-20)) + 'px' }">
        <CECourseReviewsDetails v-for="(card, i) in cards" :key="i" :cardData="card"  type="Reviews" />
    </div>
    <div class="carousel-control-one" v-if="type === 'CECourseOne'">
        <a @click.prevent="setActiveCardIndex(i)" v-for="(card, i) in cards" :key="i" :class="{ active: activeCardIndex === i }"></a>
    </div>
    <div v-else class="carousel-control">
        <a @click.prevent="setActiveCardIndex(i)" v-for="(card, i) in cards" :key="i" :class="{ active: activeCardIndex === i }"></a>
    </div>
</div>
</template>

<script>
import ArticleCard from "@/components/ContentSite/Cards/ArticleCard.vue";
import ActionCard from "@/components/ContentSite/Cards/ActionCard.vue";
import CECourseCard from "@/components/Dashboard/CECoursesHomeDetails/CECourseCard.vue";
import CECourseReviewsDetails from "@/components/Dashboard/CECourseLandingDetails/CECourseReviewsDetails.vue";

export default {
    name: "CardsCarousel",
    components: {
        ArticleCard,
        ActionCard,
        CECourseCard,
        CECourseReviewsDetails
    },
    props: {
        cards: Array,
        type: String
    },
    computed: {
        pixelsToMovePerSwipe() {
            return -(this.cssValues.mobileCardWidth) * this.activeCardIndex;
        },
    },
    methods: {
        handleTouchStart(event) {
            const firstTouch = event.touches[0];
            this.touchStart.x = firstTouch.clientX;
            this.touchStart.y = firstTouch.clientY;
        },
        handleTouchEnd(event) {
            if (!this.touchStart.x || !this.touchStart.y) {
                return;
            }

            const xEnd = event.changedTouches[0].clientX;
            const yEnd = event.changedTouches[0].clientY;

            const xDiff = this.touchStart.x - xEnd;
            const yDiff = this.touchStart.y - yEnd;

            this.touchStart = {
                x: null,
                y: null
            };

            this.moveCard(xDiff, yDiff);
        },
        moveCard(xDiff, yDiff) {
            const slideSensitivity = 60;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                if (xDiff < -1 * slideSensitivity) {
                    if (this.activeCardIndex > 0) {
                        this.setActiveCardIndex(this.activeCardIndex - 1);
                    }
                } else if (xDiff > slideSensitivity) {
                    if (this.activeCardIndex < this.cards.length - 1) {
                        this.setActiveCardIndex(this.activeCardIndex + 1);
                    }
                }

            }
        },
        setActiveCardIndex(i) {
            this.activeCardIndex = i;
        },
    },
    data() {
        return {
            activeCardIndex: 0,
            touchStart: {
                x: null,
                y: null,
            },
            cssValues: {
                mobileCardWidth: 240,
                spaceBetweenCards: 20,
                mobileScaleRatio: 0.85
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.cards-carousel {
    max-width: $page-width-padded;
    overflow-x: hidden;

    .carousel-container {
        display: flex;
        justify-content: space-between;
    }

    .carousel-container-one {
        display: flex;
        justify-content: center;
    }

    .carousel-container-two {
        display: flex;
        justify-content: center;
        gap: 16px;
    }


}

@include tablet {
    .cards-carousel {
        padding: $spacer-three $spacer-four;
        margin: -$spacer-three;
    }

    .carousel-control {
        display: none;
    }
}

@include wide-mobile {
    .cards-carousel {
        width: 100%;
        padding: $spacer-three 0;
        margin: -$spacer-three 0;

        .carousel-container {
            margin: 0 auto;
            width: 240px;
            position: relative;
            transition: all 0.3s ease-in-out;

            &>* {
                width: 240px;
                transform: scale(0.85);
                transition: all 0.15s linear, margin 0.3s linear 0.3s;

                &.active {
                    transform: scale(1);
                }
            }
        }

            .carousel-control-one {
               padding: $spacer-five;
                background-color: white;
            }

        .carousel-container-two {
            margin: 0 auto;
            width: 240px;
            position: relative;
            transition: all 0.3s ease-in-out;
            justify-content: initial;
            gap: 0px;

            &>* {
                width: 240px;
                transform: scale(0.85);
                transition: all 0.15s linear, margin 0.3s linear 0.3s;

                &.active {
                    transform: scale(1);
                }
            }
        }

        .carousel-control {
            padding: $spacer-five;
            text-align: center;

            a {
                display: inline-block;
                margin: 0 10px;
                height: 15px;
                width: 15px;
                background-color: $grayscale-five;
                border-radius: 10px;
                transition: $transition-primary;
                transition: all 0.3s ease-in-out;

                &.active {
                    background-color: $primary;
                }
            }
        }
        .reviews-container{
        width: 272px!important;
        margin-right: 72px !important;
        }

    }
}
</style>
